"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_PUNCH_CORRECTION_API = exports.ACCEPT_PUNCH_CORRECTION_API = exports.GET_PUNCH_CORRECTIONS_API = exports.GET_TIMEOFF_PAYPERIOD_API = exports.SUBMIT_PUNCH_CTK_API = exports.SUBMIT_PUNCH_API = exports.GET_PUNCH_LOCKOUT_STATUS_API = exports.DELETE_PUNCH_API = exports.GET_PUNCHES_ELIGIBILITY_API = exports.GET_PUNCHES_API = exports.ApiRoot = void 0;
var query_string_1 = require("query-string");
var ApiRoot;
(function (ApiRoot) {
    ApiRoot["PunchesEligibility"] = "/punch/eligibility";
    ApiRoot["Punches"] = "/punches";
    ApiRoot["CTKPunches"] = "/user_feedback/submit_punch";
    ApiRoot["SubmitMissingPunch"] = "/punches/submitMissingPunch";
    ApiRoot["PunchCorrections"] = "/punchCorrections";
    ApiRoot["TimeoffPayPeriod"] = "/v2/timeoff/payPeriod";
    ApiRoot["PunchLockoutStatus"] = "/associateAipLockoutStatus";
})(ApiRoot = exports.ApiRoot || (exports.ApiRoot = {}));
var parseQueryParameters = function (params) {
    var parsedParams = (0, query_string_1.stringify)(params);
    return parsedParams ? "?".concat(parsedParams) : '';
};
var appendOptionalParams = function (baseParams, params, shouldAdd) {
    return shouldAdd ? __assign(__assign({}, baseParams), params) : baseParams;
};
var GET_PUNCHES_API = function (employeeId, startDate, endDate, temporalRouting) {
    var params = appendOptionalParams({
        employeeId: employeeId,
        startDate: startDate,
        endDate: endDate
    }, {
        temporalRouting: 'true'
    }, temporalRouting);
    var queryParams = parseQueryParameters(params);
    return "".concat(ApiRoot.Punches).concat(queryParams);
};
exports.GET_PUNCHES_API = GET_PUNCHES_API;
var GET_PUNCHES_ELIGIBILITY_API = function (employeeId, startDate, endDate, temporalRouting) {
    var params = appendOptionalParams({
        employeeId: employeeId,
        startDate: startDate,
        endDate: endDate
    }, {
        temporalRouting: 'true'
    }, temporalRouting);
    var queryParams = parseQueryParameters(params);
    return "".concat(ApiRoot.PunchesEligibility).concat(queryParams);
};
exports.GET_PUNCHES_ELIGIBILITY_API = GET_PUNCHES_ELIGIBILITY_API;
var DELETE_PUNCH_API = function (employeeId) {
    var queryParams = parseQueryParameters({
        employeeId: employeeId
    });
    return "".concat(ApiRoot.Punches).concat(queryParams);
};
exports.DELETE_PUNCH_API = DELETE_PUNCH_API;
var GET_PUNCH_LOCKOUT_STATUS_API = function (employeeId) {
    var queryParams = parseQueryParameters({
        employeeId: employeeId
    });
    return "".concat(ApiRoot.PunchLockoutStatus).concat(queryParams);
};
exports.GET_PUNCH_LOCKOUT_STATUS_API = GET_PUNCH_LOCKOUT_STATUS_API;
var SUBMIT_PUNCH_API = function (employeeId) {
    var queryParams = parseQueryParameters({
        employeeId: employeeId
    });
    return "".concat(ApiRoot.SubmitMissingPunch).concat(queryParams);
};
exports.SUBMIT_PUNCH_API = SUBMIT_PUNCH_API;
var SUBMIT_PUNCH_CTK_API = function () { return "".concat(ApiRoot.CTKPunches); };
exports.SUBMIT_PUNCH_CTK_API = SUBMIT_PUNCH_CTK_API;
var GET_TIMEOFF_PAYPERIOD_API = function (employeeId) {
    var queryParams = parseQueryParameters({
        employeeId: employeeId
    });
    return "".concat(ApiRoot.TimeoffPayPeriod).concat(queryParams);
};
exports.GET_TIMEOFF_PAYPERIOD_API = GET_TIMEOFF_PAYPERIOD_API;
var GET_PUNCH_CORRECTIONS_API = function (employeeId, startDateTime, endDateTime) {
    var queryParams = parseQueryParameters({
        employeeId: employeeId,
        startDateTime: startDateTime,
        endDateTime: endDateTime
    });
    return "".concat(ApiRoot.PunchCorrections).concat(queryParams);
};
exports.GET_PUNCH_CORRECTIONS_API = GET_PUNCH_CORRECTIONS_API;
var ACCEPT_PUNCH_CORRECTION_API = function (employeeId, correctionId) {
    var queryParams = parseQueryParameters({
        employeeId: employeeId,
        correctionId: correctionId
    });
    return "".concat(ApiRoot.PunchCorrections).concat(queryParams);
};
exports.ACCEPT_PUNCH_CORRECTION_API = ACCEPT_PUNCH_CORRECTION_API;
var UPDATE_PUNCH_CORRECTION_API = function (employeeId, correctionId) {
    var queryParams = parseQueryParameters({
        employeeId: employeeId,
        correctionId: correctionId
    });
    return "".concat(ApiRoot.PunchCorrections).concat(queryParams);
};
exports.UPDATE_PUNCH_CORRECTION_API = UPDATE_PUNCH_CORRECTION_API;
